module.exports = __webpack_public_path__ + "2cfc6ab1a2d9bdc9afa9246f8db7e262.png";